import Vue from "vue";

Vue.filter("cfSplitBy", function (value, split = "-", index = 0) {
  return value.split(split)[index];
});
